import * as React from 'react';
import type { PageProps } from 'gatsby';
import { Helmet } from 'react-helmet';
import favicon from '../../images/favicon.png';

interface SEOProps {
	title: string;
	desc: string;
}

const SEO: React.FC<SEOProps> = (props: SEOProps) => {
	return (
		<Helmet>
			<title>{props.title}</title>
			<meta name="description" content={props.desc} />
			<link rel="preconnect" href="https://fonts.googleapis.com" />
			<link rel="preconnect" href="https://fonts.gstatic.com" />
			<link rel="preconnect" href="https://fonts.googleapis.com" />
			<link rel="preconnect" href="https://fonts.gstatic.com" />
			<link
				href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Rubik:ital,wght@0,300..900;1,300..900&display=swap"
				rel="stylesheet"
			></link>
			<script src="https://fast.wistia.net/player.js" async></script>
			<link rel="icon" type="image/png" href={favicon} sizes="32x32" />
		</Helmet>
	);
};

export default SEO;
